export const KELASS_GET = 'KELASS_GET';
export const KELAS_JENJANGS_GET = 'KELAS_JENJANGS_GET';
export const KELAS_TINGKATS_GET = 'KELAS_TINGKATS_GET';
export const KELAS_ADD = 'KELAS_ADD';
export const KELAS_EDIT = 'KELAS_EDIT';
export const KELAS_GET = 'KELAS_GET';
export const KELASS_SYNC = 'KELASS_SYNC';
export const KELAS_DELETE = 'KELAS_DELETE';
